import React, { useEffect } from "react";
import JobHireHero from "../components/jobsHirePage/JobHireHero";
 
import Navbar from "../components/homepage/Navbar";
import Recruiters from "../components/jobsHirePage/Recruiters";
import { Header, Footer } from "../shared";

const JobsHirePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <JobHireHero />
      {/* <Recruiters /> */}
      <Footer />
    </div>
  );
};

export default JobsHirePage;
